var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeTts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "737 342 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "_632af2bdec80c410638e3d40_api-icon",
    "data-name": "632af2bdec80c410638e3d40_api-icon",
    d: "M143.962,106.291l-2.079-2.079a.385.385,0,0,0-.279-.113.406.406,0,0,0-.279.113l-3.731,3.731a9.815,9.815,0,0,0-12.432,1.191l-5,5a.394.394,0,0,0,0,.554L133.486,128a.385.385,0,0,0,.279.113.415.415,0,0,0,.279-.113l5-5a9.815,9.815,0,0,0,1.191-12.427l3.731-3.731a.4.4,0,0,0,0-.551ZM127.353,125.8a.394.394,0,0,0-.554,0l-3.265,3.265-4.427-4.427,3.27-3.27a.394.394,0,0,0,0-.554l-1.784-1.784a.394.394,0,0,0-.554,0l-3.27,3.27-2.108-2.108a.385.385,0,0,0-.279-.113.415.415,0,0,0-.279.113l-4.991,5a9.814,9.814,0,0,0-1.191,12.427l-3.731,3.731a.394.394,0,0,0,0,.554l2.079,2.079a.385.385,0,0,0,.279.113.406.406,0,0,0,.279-.113l3.731-3.731a9.815,9.815,0,0,0,12.432-1.191l5-5a.394.394,0,0,0,0-.554l-2.108-2.108,3.27-3.27a.394.394,0,0,0,0-.554Z",
    transform: "translate(632.924 237.901)",
    fill: "#0e2444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeTts);
export default __webpack_public_path__ + "static/media/welcome-tts.0c8b21da1acb6b938b7f82c2e28541b9.svg";
export { ForwardRef as ReactComponent };